import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function DoNotQuoteWarning({ company }) {
  if (!get(company, "do_not_quote")) return null;
  return (
    <Warning>
      Company {company.name} is flagged as rarely buying from us. Please ask
      them to Make Offer if interested.
    </Warning>
  );
}

DoNotQuoteWarning.propTypes = {
  company: PropTypes.shape({
    do_not_quote: PropTypes.boolean
  })
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/DoNotQuoteWarning.jsx